var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            !_vm.isSuccess
              ? _c(
                  "form",
                  {
                    staticClass: "login-form custom-form",
                    attrs: { id: "login-form", novalidate: "" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.onSubmit)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "text-center p-b-20" },
                      [
                        _c("i18n", {
                          staticClass: "subtitle p-b-20",
                          attrs: {
                            path: "JOIN_ORP_INVITE_SUB_HEADER_1",
                            tag: "p",
                            "data-testid": "join-orp-invite-sub-header"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "applicantType",
                                fn: function() {
                                  return [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(_vm.applicantType) +
                                        "\n        "
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "applicantName",
                                fn: function() {
                                  return [
                                    _c("span", {
                                      staticClass: "prp_subheader_highlight",
                                      domProps: {
                                        textContent: _vm._s(_vm.applicantName)
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "accountName",
                                fn: function() {
                                  return [
                                    _c("span", {
                                      staticClass: "prp_subheader_highlight",
                                      domProps: {
                                        textContent: _vm._s(_vm.accountName)
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "subtitle" }, [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("JOIN_PRP_INVITE_SUB_HEADER_2")) +
                              "\n      "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("ValidationProvider", {
                      attrs: {
                        name: "Password",
                        rules: "required|passwordLength|password",
                        mode: "lazy"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field input__wrap password__wrap set__password__wrap",
                                    class: { "error-focus": errors.length > 0 }
                                  },
                                  [
                                    _vm.passwordType === "checkbox"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.password,
                                              expression: "password"
                                            }
                                          ],
                                          staticClass:
                                            "login-form__field__input password-has-icon required",
                                          class: {
                                            error: errors.length > 0,
                                            valid:
                                              _vm.password.length > 0 &&
                                              errors.length == 0
                                          },
                                          attrs: {
                                            id: "password",
                                            name: "password",
                                            autocomplete: "new-password",
                                            required: "",
                                            type: "checkbox"
                                          },
                                          domProps: {
                                            checked: Array.isArray(_vm.password)
                                              ? _vm._i(_vm.password, null) > -1
                                              : _vm.password
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.password,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.password = $$a.concat([
                                                      $$v
                                                    ]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.password = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.password = $$c
                                              }
                                            }
                                          }
                                        })
                                      : _vm.passwordType === "radio"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.password,
                                              expression: "password"
                                            }
                                          ],
                                          staticClass:
                                            "login-form__field__input password-has-icon required",
                                          class: {
                                            error: errors.length > 0,
                                            valid:
                                              _vm.password.length > 0 &&
                                              errors.length == 0
                                          },
                                          attrs: {
                                            id: "password",
                                            name: "password",
                                            autocomplete: "new-password",
                                            required: "",
                                            type: "radio"
                                          },
                                          domProps: {
                                            checked: _vm._q(_vm.password, null)
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.password = null
                                            }
                                          }
                                        })
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.password,
                                              expression: "password"
                                            }
                                          ],
                                          staticClass:
                                            "login-form__field__input password-has-icon required",
                                          class: {
                                            error: errors.length > 0,
                                            valid:
                                              _vm.password.length > 0 &&
                                              errors.length == 0
                                          },
                                          attrs: {
                                            id: "password",
                                            name: "password",
                                            autocomplete: "new-password",
                                            required: "",
                                            type: _vm.passwordType
                                          },
                                          domProps: { value: _vm.password },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.password = $event.target.value
                                            }
                                          }
                                        }),
                                    _vm._v(" "),
                                    _c("label", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "INPUT_NEW_PASSWORD",
                                          expression: "'INPUT_NEW_PASSWORD'"
                                        }
                                      ],
                                      staticClass: "login-form__field__label",
                                      attrs: { for: "password" }
                                    }),
                                    _vm._v(" "),
                                    _c("a", {
                                      staticClass: "icon--password fa fa-eye",
                                      on: {
                                        click: function($event) {
                                          return _vm.showPassword(
                                            "passwordType"
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "error-tooltip__wrap" },
                                      [
                                        _c("h4", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value: "INPUT_PASSWORD_ERROR",
                                              expression:
                                                "'INPUT_PASSWORD_ERROR'"
                                            }
                                          ],
                                          staticClass:
                                            "menu-link up-text error-tooltip__content"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "description xxs-visible"
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(errors[0]) +
                                                "\n          "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("ValidationProvider", {
                      attrs: {
                        name: "Password Confirmation",
                        rules: "required|passwordMatch:@Password",
                        mode: "lazy"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field input__wrap password__wrap set__password__wrap",
                                    class: { "error-focus": errors.length > 0 }
                                  },
                                  [
                                    _vm.confirmPasswordType === "checkbox"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.confirmPassword,
                                              expression: "confirmPassword"
                                            }
                                          ],
                                          staticClass:
                                            "login-form__field__input password-has-icon required",
                                          class: {
                                            error: errors.length > 0,
                                            valid:
                                              _vm.confirmPassword.length > 0 &&
                                              errors.length == 0
                                          },
                                          attrs: {
                                            id: "confirmPassword",
                                            name: "confirmPassword",
                                            autocomplete: "new-password",
                                            required: "",
                                            type: "checkbox"
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.confirmPassword
                                            )
                                              ? _vm._i(
                                                  _vm.confirmPassword,
                                                  null
                                                ) > -1
                                              : _vm.confirmPassword
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.confirmPassword,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.confirmPassword = $$a.concat(
                                                      [$$v]
                                                    ))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.confirmPassword = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.confirmPassword = $$c
                                              }
                                            }
                                          }
                                        })
                                      : _vm.confirmPasswordType === "radio"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.confirmPassword,
                                              expression: "confirmPassword"
                                            }
                                          ],
                                          staticClass:
                                            "login-form__field__input password-has-icon required",
                                          class: {
                                            error: errors.length > 0,
                                            valid:
                                              _vm.confirmPassword.length > 0 &&
                                              errors.length == 0
                                          },
                                          attrs: {
                                            id: "confirmPassword",
                                            name: "confirmPassword",
                                            autocomplete: "new-password",
                                            required: "",
                                            type: "radio"
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.confirmPassword,
                                              null
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              _vm.confirmPassword = null
                                            }
                                          }
                                        })
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.confirmPassword,
                                              expression: "confirmPassword"
                                            }
                                          ],
                                          staticClass:
                                            "login-form__field__input password-has-icon required",
                                          class: {
                                            error: errors.length > 0,
                                            valid:
                                              _vm.confirmPassword.length > 0 &&
                                              errors.length == 0
                                          },
                                          attrs: {
                                            id: "confirmPassword",
                                            name: "confirmPassword",
                                            autocomplete: "new-password",
                                            required: "",
                                            type: _vm.confirmPasswordType
                                          },
                                          domProps: {
                                            value: _vm.confirmPassword
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.confirmPassword =
                                                $event.target.value
                                            }
                                          }
                                        }),
                                    _vm._v(" "),
                                    _c("label", {
                                      directives: [
                                        {
                                          name: "t",
                                          rawName: "v-t",
                                          value: "INPUT_CONFIRM_PASSWORD",
                                          expression: "'INPUT_CONFIRM_PASSWORD'"
                                        }
                                      ],
                                      staticClass: "login-form__field__label",
                                      attrs: { for: "confirmPassword" }
                                    }),
                                    _vm._v(" "),
                                    _c("a", {
                                      staticClass: "icon--password fa fa-eye",
                                      on: {
                                        click: function($event) {
                                          return _vm.showPassword(
                                            "confirmPasswordType"
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "error-tooltip__wrap" },
                                      [
                                        _c("h4", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value: "INPUT_PASSWORD_ERROR",
                                              expression:
                                                "'INPUT_PASSWORD_ERROR'"
                                            }
                                          ],
                                          staticClass:
                                            "menu-link up-text error-tooltip__content"
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "description xxs-visible"
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(errors[0]) +
                                                "\n          "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("ValidationProvider", {
                      attrs: { rules: { required: { allowFalse: false } } },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c(
                                  "fieldset",
                                  {
                                    staticClass:
                                      "login-form__field login-form__field--checkbox checkbox__wrap"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.tosAccepted,
                                          expression: "tosAccepted"
                                        }
                                      ],
                                      staticClass:
                                        "login-form__field__input--checkbox",
                                      attrs: {
                                        id: "tos.checkbox",
                                        type: "checkbox",
                                        name: "tos.checkbox"
                                      },
                                      domProps: {
                                        checked: Array.isArray(_vm.tosAccepted)
                                          ? _vm._i(_vm.tosAccepted, null) > -1
                                          : _vm.tosAccepted
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.tosAccepted,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.tosAccepted = $$a.concat([
                                                  $$v
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.tosAccepted = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.tosAccepted = $$c
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "login-form__field__label login-form__field__label--checkbox",
                                        attrs: { for: "tos.checkbox" }
                                      },
                                      [
                                        _vm._v(
                                          "\n          " +
                                            _vm._s(
                                              _vm.$t("JOIN_INVITE_TERMS_PREFIX")
                                            ) +
                                            " \n          "
                                        ),
                                        _c("u", [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "home_link",
                                              attrs: {
                                                href:
                                                  "http://www.ringba.com/terms",
                                                target: "_BLANK"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "JOIN_INVITE_TERMS_LINK"
                                                    )
                                                  ) +
                                                  " \n          "
                                              )
                                            ]
                                          )
                                        ]),
                                        _vm._v(
                                          "  \n          " +
                                            _vm._s(
                                              _vm.$t("JOIN_INVITE_TERMS_AND")
                                            ) +
                                            "\n          "
                                        ),
                                        _c("u", [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "home_link",
                                              attrs: {
                                                href:
                                                  "http://www.ringba.com/privacy",
                                                target: "_BLANK"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "JOIN_INVITE_PRIVACY_POLICY"
                                                    )
                                                  ) +
                                                  "\n            "
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "transition",
                                      { attrs: { name: "backend-error-fade" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: errors.length > 0,
                                                expression: "errors.length > 0"
                                              }
                                            ],
                                            staticClass: "text-center p-t-5"
                                          },
                                          [
                                            _c("p", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value: "TERMS_EROR",
                                                  expression: "'TERMS_EROR'"
                                                }
                                              ],
                                              staticClass: "text-danger"
                                            })
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "fieldset",
                      {
                        staticClass:
                          "login-form__field login-form__field--button"
                      },
                      [
                        _c(
                          "SubmitButton",
                          { attrs: { pending: _vm.isPending } },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t("JOIN_PRP_INVITE_BUTTON")) +
                                " \n      "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "transition",
                      { attrs: { name: "backend-error-fade" } },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showErrorMsg,
                                expression: "showErrorMsg"
                              }
                            ],
                            staticClass: "text-center p-t-5"
                          },
                          [
                            _c("p", { staticClass: "text-danger" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.actionStatus.error) +
                                  "\n        "
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isSuccess
              ? _c("div", { staticClass: "success-message text-center" }, [
                  _c("h1", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: _vm.$t("JOIN_ORP_INVITE_SUCCESS", {
                          applicantType: _vm.applicantType
                        }),
                        expression:
                          "$t('JOIN_ORP_INVITE_SUCCESS', { applicantType })"
                      }
                    ],
                    staticClass: "title md-title"
                  }),
                  _vm._v(" "),
                  _c("p", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "JOIN_INVITE_SUCCESS_SUBHEADER",
                        expression: "'JOIN_INVITE_SUCCESS_SUBHEADER'"
                      }
                    ],
                    staticClass: "subtitle"
                  }),
                  _vm._v(" "),
                  _c("a", {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "BACK_LOGIN_LINK",
                        expression: "'BACK_LOGIN_LINK'"
                      }
                    ],
                    staticClass: "button button--transparent-grad pulse m-t-20",
                    attrs: { href: "#" },
                    on: { click: _vm.goToLogin }
                  })
                ])
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }